module.exports = __webpack_public_path__ + "static/media/matilde-hat-china-impressed.67940d44.png";